import React from 'react'
import { VersionChangesListProps } from './VersionChangesList.types'
import styles from './VersionChangesList.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'
import { ChangePlate } from 'components/shared'

const VersionChangesListComponent = (props: VersionChangesListProps) => {
  const {
    className,
    style,
    [AGREEMENT_PAGE_STORE]: {
      changes
    }
  } = props

  return (
    <div
      className={cl(styles.container, styles.scrollable, className)}
      style={style}
    >
      {changes.map((changes, index) => {
        return (
          <ChangePlate
            key={index}
            forceHideButtons
            {...changes}
          />
        )
      })}
    </div>
  )
}

const VersionChangesList = inject(
  AGREEMENT_PAGE_STORE
)(observer(VersionChangesListComponent))
export { VersionChangesList }
